import { render, staticRenderFns } from "./InventoryTemplateWizardComponent.vue?vue&type=template&id=26e66386&"
import script from "./InventoryTemplateWizardComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryTemplateWizardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports